import { Component } from '@angular/core';

@Component({
  selector: 'app-investors-agents',
  templateUrl: './investors-agents.component.html',
  styleUrl: './investors-agents.component.scss'
})
export class InvestorsAgentsComponent {

}
